// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ril-caption,\n.ril__caption {\n  justify-content: center !important;\n}\n", "",{"version":3,"sources":["webpack://./src/assets/styles/imageViewDialog.less"],"names":[],"mappings":"AAAA;;EACE,kCAAA;AAEF","sourcesContent":[".ril-caption, .ril__caption {\n  justify-content: center !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
